const INITIAL_PARAMETERS = [
    { title: 'Lowercase letter', type: 'lowercase', regex: /[a-z]/ },
    { title: 'Capital letter', type: 'capital', regex: /[A-Z]/ },
    { title: 'Number', type: 'number', regex: /[0-9]/ },
    { title: 'Symbol', type: 'symbol', regex: /[|\\/~^:,;?!&%$@*+#]/ },
    { title: 'Min of 8 characters', type: 'min', regex: /^.{8,}$/ },
];
export class PasswordValidator {
    constructor(validationParams = INITIAL_PARAMETERS) {
        this.validationParams = validationParams;
        if (!validationParams) {
            throw new Error('validationParams no set');
        }
    }
    validate(password) {
        return this.validationParams.every((param) => param.regex.test(password));
    }
    explain(password) {
        const failedParams = this.validationParams.filter((param) => !param.regex.test(password));
        return failedParams.map((param) => param.title);
    }
}
//# sourceMappingURL=PasswordValidator.js.map